import { useState } from "react";
import Property from "@/src/components/Properties/components/Property";
import Properties, { sliderItemClass } from "@/src/components/Properties";
import MarketplaceModal from "@/src/components/Modal/MarketplaceModal";
import { TokenMetadataType } from "@/src/types";
import { PropertyCollectionLink } from "@/src/components/Properties/components/PropertyCollectionLink";
import { FormattedTokenAttributeRarity } from "@/src/routes/collections/routes/[collectionName]/routes/products/routes/[productName]/routes/tokens/routes/[tokenId]/types";
import { combineTokenDataAndTokenAttributeData } from "./helpers";
import TokenPropertiesView from "./TokenPropertiesView";

export type TokenPropertiesProps = Pick<TokenMetadataType, "attributes"> & {
  tokenId: string;
  collectionSlug: string;
  tokenRarityData: FormattedTokenAttributeRarity;
};

const TokenProperties: React.FC<TokenPropertiesProps> = ({
  tokenRarityData,
  attributes,
  collectionSlug,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const data = combineTokenDataAndTokenAttributeData(
    attributes,
    tokenRarityData,
  );

  const properties = data.map((tokenProperty, i) => (
    <PropertyCollectionLink
      key={i}
      collectionSlug={collectionSlug}
      tokenProperty={tokenProperty}
    >
      <Property tokenProperty={tokenProperty} className={sliderItemClass} />
    </PropertyCollectionLink>
  ));

  return (
    <>
      <TokenPropertiesView onClick={() => setModalOpen(true)}>
        <Properties sliderMode={true}>{properties}</Properties>
      </TokenPropertiesView>
      <MarketplaceModal
        isOpen={modalOpen}
        classes={{ modal: "border border-gray-500" }}
        onClose={() => setModalOpen(false)}
        title="Properties"
      >
        <Properties sliderMode={false}>{properties}</Properties>
      </MarketplaceModal>
    </>
  );
};

export default TokenProperties;
